package pt.at.oss.kotlin.manual.storage.common.contactname

import kotlinx.serialization.Serializable
import pt.at.oss.kotlin.manual.storage.common.contactname.generationidentifiers.GenerationIdentifiersEntry
import pt.at.oss.kotlin.manual.storage.common.contactname.middlenames.MiddleNamesEntry
import pt.at.oss.kotlin.manual.storage.common.contactname.suffixes.SuffixesEntry
import pt.at.oss.kotlin.manual.storage.common.contactname.titles.TitlesEntry
import pt.lightweightform.kotlin.storage.BaseRecord

/**
 * ContactName Serializable object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
@Serializable
data class ContactName(
    var type: String? = null,
    var precedingTitle: String = "",
    var firstName: String = "",
    var lastNamePrefix: String = "",
    var lastName: String = "",
    var generalSuffix: String = "",
    var maidenName: String = "",
    var titles: MutableList<TitlesEntry> = mutableListOf(),
    var middleNames: MutableList<MiddleNamesEntry> = mutableListOf(),
    var generationIdentifiers: MutableList<GenerationIdentifiersEntry> = mutableListOf(),
    var suffixes: MutableList<SuffixesEntry> = mutableListOf(),
    var freeText: String = ""
) : BaseRecord()
